module.exports = __webpack_public_path__ + "img/img-play8.ed0acdef.png";